// extracted by mini-css-extract-plugin
export default {"inputModalCon":"inputModal_inputModalCon__Gvv6M","titleInput":"inputModal_titleInput__4PIz1","input":"inputModal_input__-kDjC","buttonContainer":"inputModal_buttonContainer__AcxMa"};